import React, { useState } from 'react';

// --- 1. Concept Creation Modal Component ---
export const ConceptCreationModal = ({ isOpen, onClose, onCreate }) => {
    const [code, setCode] = useState('');
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (code.trim() && name.trim()) {
            onCreate(code.trim(), name.trim(), description.trim());
            setCode('');
            setName('');
            setDescription('');
            onClose();
        } else {
            alert('Concept Code and Name are required.');
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-2xl w-full max-w-md">
                <h3 className="text-xl font-bold mb-4 text-gray-800">✨ Create New Concept</h3>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Concept Code (Required, Unique)</label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded-md p-2 focus:ring-gray-500 focus:border-gray-500"
                            value={code}
                            onChange={(e) => setCode(e.target.value.toUpperCase().replace(/\s/g, '_'))}
                            placeholder="E.g., GEOM_TRIG_01"
                            required />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Concept Name (Required, Unique)</label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded-md p-2 focus:ring-gray-500 focus:border-gray-500"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="E.g., Introduction to Triangles"
                            required />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Description (Optional)</label>
                        <textarea
                            className="w-full border border-gray-300 rounded-md p-2 resize-none"
                            rows="3"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Brief description of the concept content." />
                    </div>
                    <div className="flex justify-end space-x-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-900 transition-colors"
                        >
                            Create Concept
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
